import { forEach, get, isEmpty, isString, toLower, upperFirst } from 'lodash';
import { type } from '@mews-framework/utils';

export default function TextComponent({ getTexts }: $TSFixMe) {
    return type.create(TextComponent, {
        // @ts-expect-error $TSFixMeError: A spread argument must either have a tuple type or be passed to a rest parameter.
        get: (...args: $TSFixMe[]) => translate(getTexts(), ...args),
    });
}
TextComponent.translate = translate;

export const TextService = { get: translate };

function translate(texts: $TSFixMe, key: $TSFixMe, localizationInfo: $TSFixMe, substitutes = {}, options = {}) {
    if (!isString(key) || isEmpty(key)) {
        throw new TypeError('Expected the key to be a non-empty string.');
    }

    const { languageCodes } = localizationInfo;
    return translateToLanguage(texts, key, languageCodes, substitutes, options);
}

function translateToLanguage(
    texts: $TSFixMe,
    key: $TSFixMe,
    languageCodes: $TSFixMe,
    substitutes: $TSFixMe,
    { fallbackToKey = true, highlightMissingKey = false }
) {
    if (isEmpty(languageCodes)) {
        if (!fallbackToKey) {
            return null;
        }

        if (highlightMissingKey) {
            return surroundWithBrackets(key);
        }

        return toLowerWithFirstUpper(splitToWords(key));
    }

    const [languageCode, ...fallbackLanguageCodes] = languageCodes;
    const scope = get(texts, [languageCode], {});

    let translation = scope[key];
    if (isEmpty(translation)) {
        return translateToLanguage(texts, key, fallbackLanguageCodes, substitutes, {
            fallbackToKey,
            highlightMissingKey,
        });
    }

    forEach(substitutes, (value, placeholder) => {
        var re = new RegExp('{' + placeholder + '}', 'g');
        translation = translation.replace(re, value);
    });

    return translation;
}

function surroundWithBrackets(key: $TSFixMe) {
    return `[[ ${key} ]]`;
}

function splitToWords(key: $TSFixMe) {
    return key.split(/(?=[A-Z])/).join(' ');
}

function toLowerWithFirstUpper(text: $TSFixMe) {
    return upperFirst(toLower(text));
}
